import { Component, OnInit } from '@angular/core';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { constants } from 'src/app/shared/common/contants';
import { CommonService } from 'src/app/shared/services/common.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { log } from 'console';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ReportingServiceService } from 'src/app/shared/services/reporting-service.service';
import { FormsModule, NgModel } from '@angular/forms';
import { UntypedFormGroup, Validators, UntypedFormControl, UntypedFormBuilder, FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { FormFieldsTrimer } from 'src/app/shared/Validations/FormFieldsTrimer';
import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import { EtlService } from '../vault-data-migration-etl/etl.service';
import { Router } from '@angular/router';
import { VaultObjectgroupService } from '../vaultobject-popup-screen/vault-objectgroup.service';
import { MatDialog } from "@angular/material/dialog";
import { ImportJsonComponent } from 'src/app/shared/common/ImportJsonComponent ';

import { UserRoutingModule } from '../user-routing/user-routing.module';
import { ReportlinksserviceService } from '../reportlinks/reportlinksservice.service';



export interface Constants {
  name: string, 
  value: string
}

@Component({
    selector: 'app-mapping-file-automation',
    templateUrl: './mapping-file-automation.component.html',
    styleUrls: ['./mapping-file-automation.component.scss'],
    standalone: false
})
export class MappingFileAutomationComponent implements OnInit {
  navLinks = [ 
      {
        label: 'Objects',
        link: 'trnxBaseComponent?screenType=Dynamic%2FTransactions&tableName=objectmetadata&headerNameHtml=Objects',
        index: 0
      },
      {
        label: 'Stage Objects',
        link: 'stageobject',
        index: 1
      },
      {
        label: 'Objects Mapping',
        link: 'mappingconfiguration',
        index: 1
      },
      {
        label: 'Attributes Mapping',
        link: 'attributemappingconfig',
        index: 1
      },
      {
        label: 'Value Mapping',
        link: 'fieldMapping',
        index: 1
      },
       {
        label: 'Exception Queries',
        link: 'exceptionQueries',
        index: 1
      }
      
    ];
  mappingdto={
    'stageobject':'',
    'stageobjectid':'',
    'targetobject':'',
    'targetobjectid':'',
    'sourcedns':'',
    'sourcednsid':'',
    'targetdns':'',
    'targetdnsid':'',
    'orderId':'',
    'objectGroupName':'',
    'sourceUISection':'',
    'targetUISection':'',
     'isValidationReportRequired':'',
    'sourceParentObjectKeyColumn': [],
    'targetParentObjectKeyColumn': [],
    'transformParentObjectKeyColumn': [],
    'targetObjectPrimaryKeyColumn': [],
    'transformObjectPrimaryKeyColumn': [],
    'sourceParentObjectName': [],
    'targetObjectName': ''
  }
  mappingCreationData={ 
    'mappingconfigurationid':'',
    'stageobject':'',
    'stageobjectid':'',
    'targetobject':'',
    'targetobjectid':'',
    'sourcedns':'',
    'sourcednsid':'',
    'targetdns':'',
    'targetdnsid':'',
    'status':'',
    'tenantid':'',
    'orderId':'',
    'objectGroupName':'',
     'sourceUISection':'',
    'targetUISection':'',
     'isValidationReportRequired':'',
     'sourceParentObjectKeyColumn': [],
  'sourceParentObjectName': [],
  'transformParentObjectKeyColumn': [],
  'transformObjectPrimaryKeyColumn': [],
  'targetParentObjectKeyColumn': [],
  'targetObjectPrimaryKeyColumn': [],
  'targetObjectName': ''

    }
  selectedSourceName: any;
  SourceId: any;
  targetId: any;
  showGrid: boolean;
  showGridTarget: boolean;

  orderId;

objectGroupName:any;
objectGroupNameId:any;
objectGroupData:any=[];
Source_UI_Section:any;
Target_UI_Section:any;
  constructor( private dialog: MatDialog,private constants: constants, private localStorageSettings: LocalStorageSettingsService,private commonService:CommonService,private spinner: NgxUiLoaderService,private snackbar: MatSnackBar,
    private service: ReportingServiceService, private etlservice:EtlService, private router: Router,private vaultObjectService: VaultObjectgroupService,
  private userRoutingModule: UserRoutingModule,private reportLinkService:ReportlinksserviceService,) { 

    this.components = {
          buttonRenderer: Actionbutton,
        }
  }

  backgroundColorScreen = "";
  formValidOrderBy: UntypedFormGroup;
  validations_form: UntypedFormGroup;
  validation_messages
  
  columnDefsForObjects;
  columnDefsForTargetObjects;

  columnDefsForTablesFields
  defaultColDef
  defaultTargetColDef
  defaultMappingColDef
  rowSelection;
  rowSelectionForTablesFields;

  rowData: any[] = [];
  targetData: any[] = [];
  gridData:any[]=[];

  buttonColor = "";
  rowbindingdata
  columnDefs
  rowClassRules;
  getRowStyle;
  defaultLoginDns
  dnsEvnName
  recordDnsName
  recortargetdDnsName
  dnsid
  defaultId
  vaultids
  dnsnames
  targetdnsnames
  name
  targetnames
  public selectedTarget: string ;
  selectedTargetId
  ObjectGrid;
  targetObjectGrid;
  mappingGrid;
  activeFlag: string = "Yes"; 

  ObjectsData: any = []
  paramstemp
  targetparamstemp

  sourcednsid

  targetdnsid
  sourcedns

  targetdns
  lastpage;

  currentpage;

  nextpage;

  nextpageplusone;

  totalpages;

  pagesize;
  paginationPageSize;

  paginationNumberFormatter;
  components: any;
  gridApi;
  gridColumnApi
  getdata: any = []

  fieldsData: any = [];

  selectedFieldsData: any =[];
  targetfieldsData: any = [];

  targetselectedFieldsData: any = [];
  sharedData
  butttonname
  mappingCreationUpdateId
  importExportTableName = "mappingconfiguration";
  
  buttonIdList = []

  objectAttributesList: any[] = [];
selectedParentKeys: string[] = [];

targetObjectAttributesList: any[] = [];
selectedTargetParentKeys: string[] = [];

selectedTransformParentKeys: string[] = [];

selectedTargetPrimaryKeys: string[] = [];

selectedTransformPrimaryKeys: string[] = [];

sourceParentObjectNameList: string[] = [];
selectedSourceParentObjectNames: string = '';
targetObjectDropdownList: any[] = [];
selectedTargetObjectName: string = '';
tempTargetObjectName: string = '';
searchText: string = '';
filteredTargetObjectList: any[] = [];


  ngOnInit(): void {
     let screenPath = this.userRoutingModule.print(this.constructor.name);
    console.log(screenPath);
    this.reportLinkService.screenoperationspermission(screenPath,this.localStorageSettings.getSettings('UserId')).subscribe(res => {
      console.log(res);
      let responsedata: any ;
      responsedata = res;
      for (let i = 0; i <responsedata.length ; i++) {
        
       this.buttonIdList.push(responsedata[i].buttonId); // Add buttonId to the list
       }
       
       this.buttonIdList.push('screen');
       console.log('Button ID List:', this.buttonIdList);
       const buttons = document.querySelectorAll('button'); // Select all buttons in the DOM
       buttons.forEach(button => {
       const buttonId = parseInt(button.getAttribute('id'), 10); // Get the button's id
       if (!isNaN(buttonId)) { // Only process buttons with a valid numeric id
         if (!this.buttonIdList.includes(buttonId)) {
             button.setAttribute('disabled', 'true'); // Disable the button
         } else {
             button.removeAttribute('disabled'); // Enable the button
         }
       }
       });
 
     });

    this.selectedTarget =this.localStorageSettings.getSettings("SelectedDnsName");
    this.selectedTargetId =this.localStorageSettings.getSettings("dnsName");

    console.log(this.selectedTarget);
    console.log(this.selectedTargetId);
    this.selectedTargetId= Number(this.selectedTargetId)
        console.log(this.selectedTargetId);
    this.retrieveSourceAndTarget()
     this.userDns();

    this.retrieveMappingDetails();
    console.log(this.targetdnsid)
    console.log(this.dnsid)


    this.columnDefsForObjects = [
      {
        headerName: "Stage / Source Objects",
        headerTooltip: "Stage Objects",
        tooltipValueGetter: params => "Vault Objects : " + params.value,
        field: "objectlabelWithEnvName",
        filter: "agTextColumnFilter",
        width: 400,
        headerClass: 'headerClassName'
      }
    ];

    this.columnDefsForTargetObjects = [
      {
        headerName: "Target Objects",
        headerTooltip: "Target Objects",
        tooltipValueGetter: params => "Vault Objects : " + params.value,
        field: "objectlabel",
        filter: "agTextColumnFilter",
        width: 400,
        headerClass: 'headerClassName'
      }
    ]
    this.rowClassRules = {
      "sick": function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },

    };
    this.getRowStyle = (params: any) => {
      console.log(params)
      console.log(params.data.status)
      if (params.data.status === 'No') {
        return { backgroundColor: 'rgb(211, 211, 211)' }; // Inline style for deleted rows
      }
      // return { backgroundColor: 'white', color: 'black' }; // Default style for other rows
    };


    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true,
      rowSelection: true
    };
    this.defaultTargetColDef = {
      sortable: true,
      resizable: true,
      filter: true
    };
    this.defaultMappingColDef = {
      sortable: true,
      resizable: true,
      filter: true
    };
    this.rowSelection = this.constants.rowselection;
    this.rowSelectionForTablesFields = 'single';
    this.paginationPageSize = this.constants.pagesize;
    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };

    this.columnDefs = [
      {
        headerName: 'Action', filter: false, cellRenderer: 'buttonRenderer',
        pinned: 'left',
        lockPinned: true,
        cellRendererParams: {
           values: this.buttonIdList,
         edit: this.EditIcon.bind(this),
          delete: this.deleteIcon.bind(this),
        }, width: 140

      },
      { headerName: 'Order Id',
        headerTooltip: 'Order Id',
         tooltipValueGetter: (params) => 'mappingconfigurationid : ' + params.value,
          field: 'orderId', 
          filter: 'agTextColumnFilter',
           width: 100
     },

      { headerName: 'Stage/Source',
        headerTooltip: 'Stage/Source',
         tooltipValueGetter: (params) => 'stageobject : ' + params.value,
          field: 'stageobjectlabel', 
          filter: 'agTextColumnFilter',
           width: 200
     },
     { headerName: 'Target',
        headerTooltip: 'Target',
         tooltipValueGetter: (params) => 'targetobject : ' + params.value, 
         field: 'targetobjectlabel',
          filter: 'agTextColumnFilter',
           width: 200
     },
     { headerName: 'Object Group Name',
        headerTooltip: 'Object Group Name',
         tooltipValueGetter: (params) => 'ObjectGroupName : ' + params.value, 
         field: 'objectGroupName',
          filter: 'agTextColumnFilter',
           width: 200
     },
     { headerName: 'Source UI Section',
        headerTooltip: 'Source UI Section',
         tooltipValueGetter: (params) => 'SourceUISection : ' + params.value, 
         field: 'sourceUISection',
          filter: 'agTextColumnFilter',
           width: 200
     },
     { headerName: 'Target UI Section',
        headerTooltip: 'Target UI Section',
         tooltipValueGetter: (params) => 'TargetUISection : ' + params.value, 
         field: 'targetUISection',
          filter: 'agTextColumnFilter',
           width: 200
     },
     /*
 * Sujeet Kumar
 * 21/11/2025
 * Added new UI column 'Validation Report Required' to display
 * the isValidationRequired value in the Object Mapping grid.
 */

      { headerName: 'Validation Report Required',
        headerTooltip: 'Validation Report Required',
         tooltipValueGetter: (params) => 'Validation Report Required : ' + params.value, 
         field: 'isvalidationrequired',
          filter: 'agTextColumnFilter',
           width: 200
     },
     { headerName: 'CreatedBy',
       headerTooltip: 'CreatedBy',
        tooltipValueGetter: (params) => 'createdBy : ' + params.value, 
        field: 'createdBy',
         filter: 'agTextColumnFilter',
          width: 250
    },
    { headerName: 'CreatedDate',
     headerTooltip: 'CreatedDate',
      tooltipValueGetter: (params) => 'createdDate : ' + params.value, 
      field: 'createdDate',
       filter: 'agTextColumnFilter',
        width: 200
   },
   { headerName: 'LastModifiedBy',
   headerTooltip: 'LastModifiedBy',
    tooltipValueGetter: (params) => 'lastModifiedBy : ' + params.value, 
    field: 'lastModifiedBy',
     filter: 'agTextColumnFilter',
      width: 250
   },
   { headerName: 'LastModifiedDate',
     headerTooltip: 'LastModifiedDate',
      tooltipValueGetter: (params) => 'lastModifiedDate : ' + params.value, 
      field: 'lastModifiedDate',
       filter: 'agTextColumnFilter',
        width: 200
   },
   { headerName: 'Status',
   headerTooltip: 'Status',
    tooltipValueGetter: (params) => 'status : ' + params.value, 
    field: 'status',
     filter: 'agTextColumnFilter',
      width: 100
   },
    {
    headerName: 'Source Parent Key Column',
    field: 'sourceparentobjectkeycolumn',
    width: 250,
    valueFormatter: (params) => params.value ? params.value.split(',').join(', ') : ''
  },
  {
    headerName: 'Transform Parent Key Column',
    field: 'transformparentobjectkeycolumn',
    width: 250,
    valueFormatter: (params) => params.value ? params.value.split(',').join(', ') : ''
  },
  {
    headerName: 'Target Parent Key Column',
    field: 'targetparentobjectkeycolumn',
    width: 250,
    valueFormatter: (params) => params.value ? params.value.split(',').join(', ') : ''
  },
  {
    headerName: 'Target Primary Key Column',
    field: 'targetobjectprimarykeycolumn',
    width: 250,
    valueFormatter: (params) => params.value ? params.value.split(',').join(', ') : ''
  },
  {
    headerName: 'Transform Primary Key Column',
    field: 'transformobjectprimarykeycolumn',
    width: 250,
    valueFormatter: (params) => params.value ? params.value.split(',').join(', ') : ''
  },
  {
    headerName: 'Source Parent Object Name',
    field: 'sourceparentobjectname',
    width: 250,
    valueFormatter: (params) => params.value ? params.value.split(',').join(', ') : ''
  },
  {
  headerName: 'Target Object Name',
  headerTooltip: 'Target Object Name',
  tooltipValueGetter: (params) => 'Target Object Name : ' + params.value,
  field: 'targetobjectname',
  filter: 'agTextColumnFilter',
  width: 200
},

    ];


    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");
 
    let tenantid = localStorage.getItem("dnsName");
  
 
  }

  

    //excel export function
    onBtExport() {
      this.rowbindingdata.api.exportDataAsCsv();
    }
    ///
    //pagination code
onPaginationChanged() {
  console.log(this.rowbindingdata)
  if (this.rowbindingdata.api) {
    this.lastpage = this.rowbindingdata.api.paginationIsLastPageFound();
    this.currentpage = this.rowbindingdata.api.paginationGetCurrentPage() + 1
    this.nextpage = this.rowbindingdata.api.paginationGetCurrentPage() + 1 + 1
    this.nextpageplusone = this.rowbindingdata.api.paginationGetCurrentPage() + 1 + 1 + 1
    this.totalpages = this.rowbindingdata.api.paginationGetTotalPages()
  }
}
//this function is for going to the given page number
onSearchChange(searchValue: number) {

  this.rowbindingdata.api.paginationGoToPage(searchValue - 1);
}

// below function is for changing the no of rows per page
onPageSizeChanged() {
  var value = this.pagesize
  this.rowbindingdata.api.setGridOption('paginationPageSize', Number(value));
}

// below function is for going to next page
onBtNext() {
  console.log("next")
  this.rowbindingdata.api.paginationGoToNextPage();
}

// below function for going to previous page
onBtPrevious() {
  console.log("previous")
  this.rowbindingdata.api.paginationGoToPreviousPage();
}

// below function for going to first page
onBtFirst() {
  console.log("first")
  this.rowbindingdata.api.paginationGoToFirstPage();
}

// below function for going to last page
onBtLast() {
  console.log("last")
  this.rowbindingdata.api.paginationGoToLastPage();
}
//pagination code ends

refreshRun() {
  console.log("Inside the refreshmethod");
  this.spinner.start();
  this.onGridReady(this.mappingGrid);
  this.spinner.stop();
}

  
retrieveSourceAndTarget() {
  console.log("Calling retrieveSourceAndTarget ******************************");

  // const dnsId = "27";
  const dnsId =  this.localStorageSettings.getSettings("WorkspaceId")
  this.spinner.start();
  this.etlservice.retrieveSourceAndTraget(dnsId, "Source").subscribe({
    next: (result) => {
     
      console.log(result);
      if (result === null) {
        console.log("No Data Found");
      } else {
        console.log(result.sourceEnvName)
        this.selectedSourceName = result.sourceEnvName;
        console.log(this.selectedSourceName)
        this.sourcedns = this.selectedSourceName
        this.targetdns = result.targetEnvName
        this.sourcednsid = result.sourceId
        this.targetdnsid = result.targetId
        console.log( result.targetEnvName)
        console.log(this.selectedTarget)
        if (this.sourcednsid) {
          this.showGrid = true;  // Only then render the grid
        }
        if(this.targetdnsid){
          this.showGridTarget =true
        }
        this.sourceDnscheck(this.sourcednsid);
        this.targetDnscheck(this.targetdnsid)
        this.getObjectGroup()
        // this.refreshGridData();
        
        // this.validations_form.get('source')?.setValue(this.selectedSource);
        
        
      }
      this.spinner.stop();
    },
    error: (err) => {
      console.error("Error snapshotDetails:", err);
      this.spinner.stop();
    }
  });
}
  valutGroupcheck(SourceId: any) {
    throw new Error('Method not implemented.');
  }
EditIcon(updatedata) {
    
  if (updatedata.rowData.status === "No") {
    this.snackbar.open(this.constants.Deleted_Dataset, "OK", { duration: 5000 });
    return;
  }
   
  this.editData(updatedata)
  // console.log(updatedata)
  // this.sharedData = updatedata.rowData;

  // //
  // this.commonService.canDeleteOrModify(updatedata.rowData.mappingconfigurationid).subscribe({
  //   next: (result) => {
  //     if (result) {
  //       this.spinner.start();
  //       this.butttonname = "Update Map"
    
  //       this.editData(updatedata)
  //     } else {
  //       this.snackbar.open("Selected mapping cannot be modified; It has been used in one or more mapping configurations", "OK", { duration: 5000 });
  //     }
  //   },
  //   error: (error) => {
  //     console.error("Edit API Error: ", error);
  //     this.snackbar.open("Error occurred while Editing", "OK", { duration: 5000 });
  //   },
  //   complete: () => {
  //     this.spinner.stop(); // Ensures spinner stops no matter what
  //     this.refreshRun();
  //   }
  // });


   
}
editData(updatedata){
  this.spinner.start();   
  //  CLEAR OLD VALUES
this.selectedParentKeys = [];

this.selectedSourceParentObjectNames = '';
this.selectedTransformParentKeys = [];
this.selectedTransformPrimaryKeys = [];
this.selectedTargetParentKeys = [];
this.selectedTargetPrimaryKeys = [];
this.selectedTargetObjectName = '';

this.selectedFieldsData = [{ objectname: updatedata.rowData.stageobject }];
this.targetselectedFieldsData = [{ objectname: updatedata.rowData.targetobject }];



//  STEP 1: set dropdown value directly (IMPORTANT)
//this.selectedTargetObjectName = updatedata.rowData.targetobject;
let tenantid = localStorage.getItem("dnsName");

// STEP 2: call backend API to get label (your requirement)
console.log(`obj---> ${updatedata.rowData.targetobjectname} tent---> ${tenantid}`);

this.commonService.getObjectLabel(
  updatedata.rowData.targetobjectname,
  Number(tenantid)
).subscribe({
  next: (label) => {

    const match = this.targetObjectDropdownList.find(
      obj => obj.objectlabel?.trim().toLowerCase() === label?.trim().toLowerCase()
    );

    if (match) {
      this.selectedTargetObjectName = match.objectname;
    }

  },
  error: () => {
    this.spinner.stop();   //  safety
  }
});
console.log("Target Object Label from DB:", this.tempTargetObjectName)
this.onGridReadyForObjects(this.ObjectGrid, updatedata.rowData.sourcednsid);
this.onGridReadyForTargetObjects(this.targetObjectGrid, updatedata.rowData.targetdnsid);

//  FETCH ATTRIBUTES AGAIN (VERY IMPORTANT)

if (updatedata.rowData.stageobject) {
  this.getObjectAttributes(updatedata.rowData.stageobject, tenantid);
}

if (updatedata.rowData.targetobject) {
  this.getTargetObjectAttributes(updatedata.rowData.targetobject, tenantid);
}


// this.tempTargetObjectName = updatedata.rowData.targetobjectname;
setTimeout(() => {

  // 🔹 MULTI SELECT (split comma values)
  this.selectedParentKeys = updatedata.rowData.sourceparentobjectkeycolumn
    ? updatedata.rowData.sourceparentobjectkeycolumn.split(',')
    : [];

  this.selectedSourceParentObjectNames = updatedata.rowData.sourceparentobjectname
  ? updatedata.rowData.sourceparentobjectname.split(',')[0]
  : '';

  this.selectedTransformParentKeys = updatedata.rowData.transformparentobjectkeycolumn
    ? updatedata.rowData.transformparentobjectkeycolumn.split(',')
    : [];

  this.selectedTransformPrimaryKeys = updatedata.rowData.transformobjectprimarykeycolumn
    ? updatedata.rowData.transformobjectprimarykeycolumn.split(',')
    : [];

  this.selectedTargetParentKeys = updatedata.rowData.targetparentobjectkeycolumn
    ? updatedata.rowData.targetparentobjectkeycolumn.split(',')
    : [];

  this.selectedTargetPrimaryKeys = updatedata.rowData.targetobjectprimarykeycolumn
    ? updatedata.rowData.targetobjectprimarykeycolumn.split(',')
    : [];

//this.tempTargetObjectName = updatedata.rowData.targetobjectname;
 this.spinner.stop();
}, 500);
  console.log(updatedata);
  
  this.mappingCreationUpdateId = updatedata.rowData.mappingconfigurationid;
    console.log(updatedata.rowData.mappingconfigurationid)
    console.log(this.mappingCreationUpdateId);
    this.mappingCreationData.mappingconfigurationid = updatedata.rowData.mappingconfigurationid
    this.mappingCreationData.sourcedns = updatedata.rowData.sourcedns
    this.mappingCreationData.targetdns = updatedata.rowData.targetdns
    this.mappingCreationData.stageobject = updatedata.rowData.stageobject
    this.mappingCreationData.targetobject = updatedata.rowData.targetobject
     this.mappingCreationData.stageobjectid=updatedata.rowData.stageobjectid
     this.mappingCreationData.targetobjectid=updatedata.rowData.targetobjectid
    this.mappingCreationData.sourcednsid = updatedata.rowData.sourcednsid
    this.mappingCreationData.targetdnsid = updatedata.rowData.targetdnsid
    this.mappingCreationData.status = updatedata.rowData.status
    this.mappingCreationData.tenantid = updatedata.rowData.tenantid
    this.mappingCreationData.orderId=updatedata.rowData.orderId
    this.mappingCreationData.objectGroupName=updatedata.rowData.objectGroupName
    this.mappingCreationData.sourceUISection=updatedata.rowData.sourceUISection
   this.mappingCreationData.targetUISection=updatedata.rowData.targetUISection
   this.mappingCreationData.isValidationReportRequired = updatedata.rowData.isvalidationrequired

    console.log(updatedata.rowData.sourcedns)

if(this.objectGroupData.length > 0){
  this.objectGroupNameId=this.objectGroupData.filter(item=>item.objectGroupName == updatedata.rowData.objectGroupName)[0].objectGroupId;
    console.log(this.objectGroupData.filter(item=>item.objectGroupName == updatedata.rowData.objectGroupName)[0]);
    console.log(this.objectGroupNameId);
    
    
}


let tenantidNum = Number(localStorage.getItem("dnsName"));
let objectGroupName = updatedata.rowData.objectGroupName;

console.log("tenantidNum:-------?", tenantidNum);
console.log("objectGroupName:------>", objectGroupName);

this.commonService.getObjectGroupIdByName(objectGroupName, tenantidNum)
  .subscribe({
    next: (groupId: number) => {

      console.log("DB Group ID:", groupId);

      // overwrite safely
      this.objectGroupNameId = groupId;

      // call same API like onObjectGroupChange
      this.commonService.retrieveObjectsBasedOnObjectGroupId(groupId)
        .subscribe((res: any) => {

          if (res.error === true) return;

          let filteredData = res.filter(item =>
            !(item.source == "stage" && item.approvedStatus == null || item.approvedStatus == "Draft")
          );

          const objects = filteredData.map((item: any, index: number) => ({
            id: item.objectId || index,
            objectlabel: item.objectlabel || item,
            objectname: item.objectname || item,
            objectlabelWithEnvName: item.objectlabelWithEnvName || item
          }));

          // ✅ ONLY THIS LINE IS IMPORTANT FOR YOU
          this.sourceParentObjectNameList = objects.map(item => item.objectname);

        });

    },
    error: (err) => {
      console.error("Error fetching groupId:", err);
    }
  });
   console.log(this.mappingCreationData)
    this.sourcedns=updatedata.rowData.sourcedns
    console.log(this.sourcedns)
    this.targetdns=updatedata.rowData.targetdns
    console.log(this.targetdns)
    this.orderId=updatedata.rowData.orderId
    this.objectGroupName=updatedata.rowData.objectGroupName
    console.log(this.ObjectGrid)
    console.log(this.targetObjectGrid)
    console.log(this.rowSelection)
    this.Source_UI_Section=updatedata.rowData.sourceUISection
    this.Target_UI_Section=updatedata.rowData.targetUISection
    this.activeFlag = updatedata.rowData.isvalidationrequired

    this.butttonname = "Update Map"

    this.onGridReadyForObjects(this.ObjectGrid,updatedata.rowData.sourcednsid);

    //this.onGridReadyForTargetObjects(this.targetObjectGrid,updatedata.rowData.targetdnsid);
// this.onObjectGroupChange();
     this.spinner.stop();



}
deleteIcon(updatedata) {
    
  console.log(updatedata)
  if (updatedata.rowData.status === "No") {
    this.snackbar.open(this.constants.Deleted_Mapping, "OK", { duration: 5000 });
    return;
  }
  console.log(updatedata)
  this.sharedData = updatedata.rowData;
    if (confirm("Are you sure you want to delete mapping?")) {
      this.spinner.start();
      this.commonService.deleteMappingConfiguration(updatedata.rowData.mappingconfigurationid).subscribe({
        next: (result) => {
          if (result.statusMessage === "Successfully record is deleted") {
            this.refreshRun(); 
            this.snackbar.open("Stage-Target object mapping deleted successfully", "OK", { duration: 5000 });
          } else {
            this.snackbar.open("Selected mapping cannot be deleted; It has been used in one or more mapping configurations", "OK", { duration: 5000 });
          }
          this.refreshRun();
        },
        error: (error) => {
          console.error("Delete API Error: ", error);
          this.snackbar.open("Error occurred while deleting", "OK", { duration: 5000 });
        },
        complete: () => {
          this.spinner.stop(); // Ensures spinner stops no matter what
          this.refreshRun();
        }
      });
    }
}


  map(ctrl,sourceUISectionCtrl,targetUISectionCtrl,
    sourceParentCtrl,
  sourceParentNameCtrl,
  transformParentCtrl,
  transformPrimaryCtrl,
  targetParentCtrl,
  targetPrimaryCtrl,
  targetObjectNameCtrl
  ){

sourceParentCtrl.control.markAsTouched();
sourceParentNameCtrl.control.markAsTouched();
transformParentCtrl.control.markAsTouched();
transformPrimaryCtrl.control.markAsTouched();
targetParentCtrl.control.markAsTouched();
targetPrimaryCtrl.control.markAsTouched();
targetObjectNameCtrl.control.markAsTouched();

if (this.activeFlag === 'Yes') {
    if (
  !this.selectedParentKeys?.length ||
  !this.selectedSourceParentObjectNames?.length ||
  !this.selectedTransformParentKeys?.length ||
  !this.selectedTransformPrimaryKeys?.length ||
  !this.selectedTargetParentKeys?.length ||
  !this.selectedTargetPrimaryKeys?.length 
) {
  this.snackbar.open("Please select all dropdown values", "OK", { duration: 5000 });
  return;
}
}

     if (ctrl.invalid || sourceUISectionCtrl.invalid || targetUISectionCtrl.invalid||
      sourceParentCtrl.invalid ||
  sourceParentNameCtrl.invalid ||
  transformParentCtrl.invalid ||
  transformPrimaryCtrl.invalid ||
  targetParentCtrl.invalid ||
  targetPrimaryCtrl.invalid ||
  targetObjectNameCtrl.invalid
     ) {
      if(ctrl.invalid){
        ctrl.control.markAsTouched();
      }
      if(sourceUISectionCtrl.invalid){
        sourceUISectionCtrl.control.markAsTouched();
      }
      if(targetUISectionCtrl.invalid){
        targetUISectionCtrl.control.markAsTouched();
      }
      
    }else{
    this.spinner.start();
    console.log(this.selectedFieldsData.length)
    console.log(this.targetselectedFieldsData.length)

    if (
      (this.selectedFieldsData && this.selectedFieldsData.length > 0) &&
      (this.targetselectedFieldsData && this.targetselectedFieldsData.length > 0)
    ) {
  
        console.log(this.selectedFieldsData[0])
        console.log(this.targetselectedFieldsData[0])

        this.mappingdto.stageobject=this.selectedFieldsData[0].objectname
        this.mappingdto.stageobjectid=this.selectedFieldsData[0].id
        this.mappingdto.targetobject=this.targetselectedFieldsData[0].objectname
        this.mappingdto.targetobjectid=this.targetselectedFieldsData[0].id
        this.mappingdto.sourcedns=this.sourcedns
        this.mappingdto.sourcednsid=this.sourcednsid
        this.mappingdto.targetdns=this.targetdns
        this.mappingdto.targetdnsid=this.targetdnsid
        this.mappingdto.orderId=this.orderId
        this.mappingdto.objectGroupName=this.objectGroupName
        this.mappingdto.sourceUISection=this.Source_UI_Section
        this.mappingdto.targetUISection=this.Target_UI_Section
        this.mappingdto.isValidationReportRequired=this.activeFlag
//         //  Source_Parent_Object_Key_Column default logic
// let parentKeysToSend = this.selectedParentKeys;

// if (!parentKeysToSend || parentKeysToSend.length === 0) {
//   if (this.objectAttributesList.length > 0) {
//     parentKeysToSend = [this.objectAttributesList[0]];
//   }
// }

// // store in DTO
// this.mappingdto.sourceParentObjectKeyColumn = parentKeysToSend;
//         console.log(this.mappingdto);




// // Transform_Parent_Object_Key_Column: dropdown default logic
// let transformKeysToSend = this.selectedTransformParentKeys;

// if (!transformKeysToSend || transformKeysToSend.length === 0) {
//   if (this.objectAttributesList.length > 0) {
//     transformKeysToSend = [this.targetObjectAttributesList[0]];
//   }
// }

// this.mappingdto.transformParentObjectKeyColumn = transformKeysToSend;




//         // Target_Parent_Object_Key_Column default logic
// let targetParentKeysToSend = this.selectedTargetParentKeys;

// if (!targetParentKeysToSend || targetParentKeysToSend.length === 0) {
//   if (this.targetObjectAttributesList.length > 0) {
//     targetParentKeysToSend = [this.targetObjectAttributesList[0]];
//   }
// }

// this.mappingdto.targetParentObjectKeyColumn = targetParentKeysToSend;

// // Target_Object_Primary_Key_Column dropdown frfault logic
// let targetPrimaryKeysToSend = this.selectedTargetPrimaryKeys;

// if (!targetPrimaryKeysToSend || targetPrimaryKeysToSend.length === 0) {
//   if (this.targetObjectAttributesList.length > 0) {
//     targetPrimaryKeysToSend = [this.targetObjectAttributesList[0]];
//   }
// }

// this.mappingdto.targetObjectPrimaryKeyColumn = targetPrimaryKeysToSend;

// // Transform_Object_Primary_key_Column: default LOGIC
// let transformPrimaryKeysToSend = this.selectedTransformPrimaryKeys;

// if (!transformPrimaryKeysToSend || transformPrimaryKeysToSend.length === 0) {

//   // if (this.Source_UI_Section && this.Target_UI_Section) {

//   //   const defaultValue =
//   //     this.Source_UI_Section + "_" +
//   //     this.Target_UI_Section + "_id";

//   //   transformPrimaryKeysToSend = [defaultValue];
//   // }
//   if (this.selectedFieldsData.length > 0 && this.targetselectedFieldsData.length > 0) {

//   const sourceObject = this.selectedFieldsData[0].objectname;
//   const targetObject = this.targetselectedFieldsData[0].objectname;

//   const defaultValue = sourceObject + "_" + targetObject + "_id";

//   transformPrimaryKeysToSend = [defaultValue];
// }
// }

// this.mappingdto.transformObjectPrimaryKeyColumn = transformPrimaryKeysToSend;

// //Source_Parent_Object_Name default logic
// //let sourceParentNamesToSend = this.selectedSourceParentObjectNames;
// let sourceParentNamesToSend = this.selectedSourceParentObjectNames 
//   ? [this.selectedSourceParentObjectNames] 
//   : [];
// // if (!sourceParentNamesToSend || sourceParentNamesToSend.length === 0) {
// //   sourceParentNamesToSend = [];// need to add logic
// // }

// this.mappingdto.sourceParentObjectName = sourceParentNamesToSend;

let targetObjectNameToSend = this.selectedTargetObjectName;

if (!targetObjectNameToSend) {
  if (this.targetselectedFieldsData.length > 0) {
    targetObjectNameToSend = this.targetselectedFieldsData[0].objectname;
  }
}

this.mappingdto.targetObjectName = targetObjectNameToSend;


        // if(this.mappingdto.stageobject==this.mappingdto.targetobject){
        //   this.snackbar.open("Stage object and target object should not be the same.", "OK", { duration: 5000 });
        // }else{
        this.commonService.insertMappingConfiguration(this.mappingdto).subscribe({
          next: (res: any) => {
              console.log("Subscribe Response:", res);
              // this.spinner.start();

   
              if (res.error === true) {
                          
                if (res.data && res.data.includes("Duplicate entry")) {
                  this.snackbar.open("Mapping alreday exists", "OK", { duration: 5000 });
                  return; // Exit function to prevent further execution
              }
              if(res.error && res.data.length == 0){
                 this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
                  return;
              }else {
                const errorMessage =
                  res.data && res.data.length > 0
                    ? res.data
                    : res.statusMessage || "Stage-Target object mapping failed";

                this.snackbar.open(errorMessage, "OK", { duration: 6000 });
                this.retrieveMappingDetails();
              }

                
                  this.spinner.stop();

                  // this.mappingGrid.api.setGridOption('rowData', []);

                  // this.rowbindingdata.api.setGridOption('rowData', [])
                } else {
                  this.spinner.stop();
                  this.snackbar.open("Stage-Target object mapped successfully", "OK", { duration: 5000 });


                 this.retrieveMappingDetails();
                  
              }
          },
          error: (error) => {
              console.error("API Error:", error);
              this.snackbar.open("Error object mapping", "OK", { duration: 5000 });
              this.spinner.stop();

          }
          
      });
    // }
  }else{
    this.snackbar.open("Please Select Stage Object and Target Object", "OK", { duration: 5000 });
  }

      this.spinner.stop();
  }
  }

  updateMapping(ctrl,sourceUISectionCtrl,targetUISectionCtrl,
    sourceParentCtrl,
  sourceParentNameCtrl,
  transformParentCtrl,
  transformPrimaryCtrl,
  targetParentCtrl,
  targetPrimaryCtrl,
  targetObjectNameCtrl
  ){
    // MARK AS TOUCHED
sourceParentCtrl.control.markAsTouched();
sourceParentNameCtrl.control.markAsTouched();
transformParentCtrl.control.markAsTouched();
transformPrimaryCtrl.control.markAsTouched();
targetParentCtrl.control.markAsTouched();
targetPrimaryCtrl.control.markAsTouched();
targetObjectNameCtrl.control.markAsTouched();

//  REQUIRED CHECK
if (this.activeFlag === 'Yes') {
if (
  !this.selectedParentKeys?.length ||
  !this.selectedSourceParentObjectNames?.length ||
  !this.selectedTransformParentKeys?.length ||
  !this.selectedTransformPrimaryKeys?.length ||
  !this.selectedTargetParentKeys?.length ||
  !this.selectedTargetPrimaryKeys?.length 
) {
  this.snackbar.open("Please select all dropdown values", "OK", { duration: 5000 });
  return;
}
}

    if (ctrl.invalid || sourceUISectionCtrl.invalid || targetUISectionCtrl.invalid) {
      if(ctrl.invalid){
        ctrl.control.markAsTouched();
      }
      if(sourceUISectionCtrl.invalid){
        sourceUISectionCtrl.control.markAsTouched();
      }
      if(targetUISectionCtrl.invalid){
        targetUISectionCtrl.control.markAsTouched();
      }
      
    }else{
    this.spinner.start();
  
        console.log(this.selectedFieldsData[0])
        console.log(this.targetselectedFieldsData[0])

        // this.mappingCreationData.stageobject=this.selectedFieldsData[0].objectname
        // this.mappingCreationData.stageobjectid=this.selectedFieldsData[0].id
        // this.mappingCreationData.targetobject=this.targetselectedFieldsData[0].objectname
        // this.mappingCreationData.targetobjectid=this.targetselectedFieldsData[0].id
       this.mappingCreationData.orderId=this.orderId
       this.mappingCreationData.objectGroupName=this.objectGroupName
       this.mappingCreationData.sourceUISection=this.Source_UI_Section
        this.mappingCreationData.targetUISection=this.Target_UI_Section
        this.mappingCreationData.isValidationReportRequired = this.activeFlag

        this.mappingCreationData.sourceParentObjectKeyColumn = this.selectedParentKeys;
this.mappingCreationData.sourceParentObjectName = this.selectedSourceParentObjectNames
  ? [this.selectedSourceParentObjectNames]
  : [];
  this.mappingCreationData.transformParentObjectKeyColumn = this.selectedTransformParentKeys;
this.mappingCreationData.transformObjectPrimaryKeyColumn = this.selectedTransformPrimaryKeys;
this.mappingCreationData.targetParentObjectKeyColumn = this.selectedTargetParentKeys;
this.mappingCreationData.targetObjectPrimaryKeyColumn = this.selectedTargetPrimaryKeys;
this.mappingCreationData.targetObjectName = this.selectedTargetObjectName;
        console.log(this.mappingCreationData);

        if(this.mappingCreationData.stageobject==this.mappingCreationData.targetobject){
          this.snackbar.open("Stage object and target object should not be the same.", "OK", { duration: 5000 });
        }

       else{
        this.commonService.updateMappingConfiguration(this.mappingCreationData).subscribe({
          next: (res: any) => {
              console.log("Subscribe Response:", res);
              // this.spinner.start();

   
              if (res.error === true) {
                          
                if (res.data && res.data.includes("Duplicate entry")) {
                  this.snackbar.open("Mapping already exists", "OK", { duration: 5000 });
                  return; // Exit function to prevent further execution
              }
                this.snackbar.open("Stage-Target object mapping update failed", "OK", { duration: 5000 });
                  this.retrieveMappingDetails();
                  this.spinner.stop();

                  // this.mappingGrid.api.setGridOption('rowData', []);

                  // this.rowbindingdata.api.setGridOption('rowData', [])
                } else {
                  if (res.statusMessage === "Successfully Updated") {
                      this.clearAllDropdowns();

                       //  RESET FORM CONTROLS (IMPORTANT)
  ctrl.reset();
  sourceUISectionCtrl.reset();
  targetUISectionCtrl.reset();

  sourceParentCtrl.reset();
  sourceParentNameCtrl.reset();
  transformParentCtrl.reset();
  transformPrimaryCtrl.reset();
  targetParentCtrl.reset();
  targetPrimaryCtrl.reset();
  targetObjectNameCtrl.reset();

  //  REMOVE RED VALIDATION STATE
sourceParentCtrl.control.markAsUntouched();
sourceParentNameCtrl.control.markAsUntouched();
transformParentCtrl.control.markAsUntouched();
transformPrimaryCtrl.control.markAsUntouched();
targetParentCtrl.control.markAsUntouched();
targetPrimaryCtrl.control.markAsUntouched();
targetObjectNameCtrl.control.markAsUntouched();

                  this.snackbar.open("Stage-Target object mapping updated successfully", "OK", { duration: 5000 });
                  this.spinner.stop();
                 this.retrieveMappingDetails();
                }
                //  else {
                //   this.snackbar.open("Selected mapping cannot be deleted; It has been used in one or more mapping configurations", "OK", { duration: 5000 });
                // }
                  
              }
          },
          error: (error) => {
              console.error("API Error:", error);
              this.snackbar.open("Error update mapping", "OK", { duration: 5000 });
              this.spinner.stop();

          }
          
      });
    }

      this.spinner.stop();
  }
  }
  cancel(ctrl: NgModel,objectGroupNameCtrl: NgModel,sourceUISectionCtrl: NgModel,targetUISectionCtrl: NgModel){
    this.butttonname = "Map"
    this.ObjectGrid.api.deselectAll(); 
    this.fieldsData = []; 
    this.selectedFieldsData = [];
    this.targetObjectGrid.api.deselectAll(); 
    this.targetfieldsData = []; 
    this.targetselectedFieldsData = [];
    console.log("Selection cleared");
      this.clearAllDropdowns();
    ctrl.reset();
    objectGroupNameCtrl.reset();
    sourceUISectionCtrl.reset();
    targetUISectionCtrl.reset();
    this.activeFlag = 'Yes'
  }
clearAllDropdowns() {
  this.selectedParentKeys = [];

this.selectedSourceParentObjectNames = '';

  this.selectedTransformParentKeys = [];
  this.selectedTransformPrimaryKeys = [];
  this.selectedTargetParentKeys = [];
  this.selectedTargetPrimaryKeys = [];
  this.selectedTargetObjectName = '';
  this.tempTargetObjectName = '';
}
  async selectDns(event) {
    console.log(this.defaultLoginDns);
   this.dnsEvnName = event?.name;
   console.log(this.dnsEvnName);

    console.log(event);
    console.log("Event type:", typeof event);
    this.recordDnsName =event
    console.log(this.recordDnsName)
    console.log(event.substring(8, event.length - 4));
  
    let tempdnschange = event;
    let dnschange = {
      "dnschange": tempdnschange,
      "username": this.localStorageSettings.getSettings("AuthUsername")
    };
  
    console.log(dnschange);
    this.spinner.start();
    console.log("Selected DNS:", dnschange);
  
  
     // First API call - Get Tenant ID based on DNS Name
    try {
      console.log("Calling API for getTenantidBasedOnEnvName...");
      const dnsvalue = await this.commonService.getTenantidBasedOnEnvName(tempdnschange).toPromise();
      this.dnsid = Number(dnsvalue)
      //
      // this.sourcednsid=this.dnsid;
      console.log("DNS ID:", this.sourcednsid);
      //
      console.log("DNS ID:", this.dnsid);
      // this.sourceDnscheck(this.dnsid);
      this.sourcedns = tempdnschange
            console.log(this.sourcednsid)
            console.log(this.sourcedns)
  
    } catch (error) {
      console.error("Error occurred:", error);
      this.spinner.stop();
      alert('An error occurred while fetching the data.');
    } finally {
      this.spinner.stop();
    }
  
    
 }

 async selectTargetDns(event) {
  console.log(this.defaultLoginDns);
 this.dnsEvnName = event?.name;
 console.log(this.dnsEvnName);

  console.log(event);
  console.log("Event type:", typeof event);
  this.recortargetdDnsName =event
  console.log(this.recortargetdDnsName)
  console.log(event.substring(8, event.length - 4));

  let tempdnschange = event;
  let dnschange = {
    "dnschange": tempdnschange,
    "username": this.localStorageSettings.getSettings("AuthUsername")
  };

  console.log(dnschange);
  this.spinner.start();
  console.log("Selected DNS:", dnschange);


  // First API call - Get Tenant ID based on DNS Name
  try {
    console.log("Calling API for getTenantidBasedOnEnvName...");
    const dnsvalue = await this.commonService.getTenantidBasedOnEnvName(tempdnschange).toPromise();
    // this.targetdnsid = Number(dnsvalue)
    
    console.log("DNS ID:", this.targetdnsid);
    // this.targetDnscheck(this.targetdnsid);
    // this.targetdns = tempdnschange

            console.log(this.targetdnsid)
            console.log(this.targetdns)
  
  } catch (error) {
    console.error("Error occurred:", error);
    this.spinner.stop();
    alert('An error occurred while fetching the data.');
  } finally {
    this.spinner.stop(); 
  }

  
}
  
  
    dnsDropDown(userid){
     console.log(userid);
     
        this.dnsnames=[];
        // this.targetdnsnames=[];
         // Return the entire promise chain
    return this.commonService.retrieveSourceDnsWithDetails(userid).toPromise()
    .then(dnsList => {
        console.log(" DNS List with Additional Details from API:", dnsList);

        this.vaultids = dnsList;  // Store retrieved vaults in the component state
        console.log(" Updated Vault IDs:", this.vaultids);

        // Extract vault names
        let vaultNames = this.vaultids.map(vault => vault.envname);
        console.log(" Vault Names:", vaultNames);

        // Check which vaults are sources
        return this.commonService.checkIfSourceOrTarget("Source",vaultNames).toPromise();
    })
    .then(sourceMap => {
        this.dnsnames = this.vaultids.filter(vault => sourceMap[vault.envname]);

      
      console.log("Final DNS list:", this.dnsnames);
        this.dnsnames.forEach(vault => {
            console.log(`${vault.envname} is a source and added to the list.`);
            console.log(" Additional Details:", vault.additionalDetails);
        });
        console.log(this.dnsnames)
        let defaultid
        if (this.dnsnames.length > 0) {
            let defaultDns = this.dnsnames[0]; // Set first DNS as default
            this.name = defaultDns.envname;
            defaultid=defaultDns.vaultconfigmstrid;
            console.log(defaultid)


            console.log(defaultDns.envname)

            this.defaultLoginDns = defaultDns;
            // this.sourcednsid=defaultid
            this.sourcednsid=defaultid
            this.sourcedns = defaultDns.envname;
            console.log(this.sourcednsid)
            console.log(this.sourcedns)
        }

        console.log(" Final DNS list:", this.dnsnames);
        // this.sourceDnscheck(defaultid);

    })
    
    .catch(error => {
        console.error(" Error:", error);
    });

   }

   targetdnsDropDown(userid){
   console.log(userid);
      this.targetdnsnames=[];
    
       // Return the entire promise chain
  return this.commonService.retrieveSourceDnsWithDetails(userid).toPromise()
  .then(dnsList => {
      console.log(" DNS List with Additional Details from API:", dnsList);

      this.vaultids = dnsList;  // Store retrieved vaults in the component state
      console.log(" Updated Vault IDs:", this.vaultids);

      // Extract vault names
      let vaultNames = this.vaultids.map(vault => vault.envname);
      console.log(" Vault Names:", vaultNames);

      // Check which vaults are sources
      return this.commonService.checkIfSourceOrTarget("Target",vaultNames).toPromise();
  })
  .then(targetMap => {
      this.targetdnsnames = this.vaultids.filter(vault => targetMap[vault.envname]);
      this.targetdnsnames.forEach(vault => {
          console.log(`${vault.envname} is a source and added to the list.`);
          console.log(" Additional Details:", vault.additionalDetails);
      });
      console.log(this.targetdnsnames)
      let defaultid
      if (this.targetdnsnames.length > 0) {
          let defaultDns = this.targetdnsnames[0]; // Set first DNS as default
          this.targetnames = defaultDns.envname;
          console.log(this.targetnames)
          this.defaultLoginDns = defaultDns;
          defaultid=defaultDns.vaultconfigmstrid;
            console.log(defaultid)
            //  this.targetdnsid=defaultid
            //  this.targetdns = defaultDns.envname
            console.log(this.targetdnsid)
            console.log(this.targetdns)
      }

      console.log(" Final DNS list:", this.targetdnsnames);
      // this.targetDnscheck(defaultid)
  })
  
  .catch(error => {
      console.error(" Error:", error);
  });

 }

   async userDns(){
    var userName = localStorage.getItem("AuthUsername");
    const dnsNameOflogined = localStorage.getItem("dnsName")
    console.log(dnsNameOflogined);
    this.dnsid = Number(dnsNameOflogined);
 
    console.log(userName);
 
    let userData: any =  await this.commonService.retrieveSingleRecordService("users", "username", userName);
 
     let userid = userData[0].userid;
    console.log("userid" + userid)
    this.dnsDropDown(userid);

     this.targetdnsDropDown(userid);
    console.log(this.dnsid)
    
  }

  

  sourceDnscheck(e) {
  console.log(e);

  if (!this.ObjectGrid?.api) {
    console.warn('Object grid is not ready yet');
    return;
  }

  this.onGridReadyForObjects(this.ObjectGrid, e);
}
  targetDnscheck(e) {
    console.log(e.value)
    this.onGridReadyForTargetObjects(this.targetObjectGrid, e)
  }

 
  onGridReadyForObjects(params: any, vaultgroup: any) {
  if (!params?.api) {
    console.error('Grid params/api not available', params);
    return;
  }

  this.ObjectGrid = params;
  this.paramstemp = params;

  this.spinner.start();

  console.log(vaultgroup);
  console.log(params);

  params.api.setGridOption('rowData', []);
}

onGridReadyForTargetObjects(params, vaultgroup) {
  this.targetObjectGrid = params;
  this.targetparamstemp = params;
if(vaultgroup){
  this.spinner.start();
  console.log(vaultgroup);

  this.commonService.retrieveObjectGroupObjectsbasedDns(vaultgroup).subscribe({
      next: (res: any) => {
          console.log("Subscribe Response:", res);

          if (res.error === true) {
              // this.snackbar.open(res.message, "OK", { duration: 5000 });
              this.targetObjectGrid.api.setGridOption('rowData', []);
          } else {
              this.ObjectsData = res;

              const objects = res.map((item: any, index: number) => ({
                  id: item.id || index, // Assign index if id is missing
                  objectlabel: item.objectlabel || item,
                    objectname: item.objectname || ""
              }));
              this.targetObjectDropdownList = objects;
              this.filteredTargetObjectList = objects;
//this.selectedTargetObjectName = this.tempTargetObjectName;


              console.log("Mapped Objects for Grid:", objects);
              this.targetObjectGrid.api.setGridOption('rowData', objects);
              // this.targetparamstemp.api.setGridOption('rowData', []);
              this.targetObjectGrid.api.forEachNode(node=>{
                //console.log("node"+node)
                //console.log(node.data.objectlabel+"============="+this.mappingCreationData.targetobject)
                if(node.data['objectname']===this.mappingCreationData.targetobject){
                  //console.log("condition")
                     node.setSelected(true)
                     this.targetObjectGrid.api.ensureNodeVisible(node);
                }
              })
          }
      },
      error: (error) => {
          console.error("API Error:", error);
          this.snackbar.open("Error retrieving data", "OK", { duration: 5000 });
      },
      complete: () => {
          this.spinner.stop();
      }
  });
}
}
retrieveMappingDetails(){
  this.commonService.retrieveMappingConfiguration().subscribe(response => {
    this.spinner.start();
    console.log(response);
    // checking if response is true or not
    if (response.error == true) {
      this.snackbar.open(response.statusMessage, "OK", {
        duration: 5000,
      });
      this.spinner.stop();
      

    } else {
      console.log(response)
      this.getdata = response
      console.log(this.getdata)
      this.gridData=this.getdata
      this.mappingGrid.api.setGridOption('rowData', this.gridData);

    }
    this.spinner.stop();
  });
}

onGridReady(params) {
  this.mappingGrid = params;

  this.rowbindingdata = params;

  this.gridData = params;
  this.getdata-params;
  console.log(this.gridData)

  this.gridApi = params.api;
  this.gridColumnApi = params.columnApi;
  console.log(params.columnApi)
  console.log(this.dnsid)
  this.retrieveMappingDetails()

}


onSourceRowSelected(event) {
  
  console.log(this.paramstemp)
  console.log(this.paramstemp.api.getSelectedRows())
  this.fieldsData = this.paramstemp.api.getSelectedRows();

  console.log(this.fieldsData)

  this.selectedFieldsData = this.fieldsData

  console.log(this.selectedFieldsData);
  this.Source_UI_Section=this.selectedFieldsData[0].objectlabel

  //   (reset previous selection)
  this.selectedParentKeys = [];
  this.objectAttributesList = [];


   if (this.selectedFieldsData && this.selectedFieldsData.length > 0) {
    const objectName = this.selectedFieldsData[0].objectname;

    console.log("Fetching object attributes for:", objectName);
    let tenantid = localStorage.getItem("dnsName")
    this.getObjectAttributes(objectName,tenantid); //  call API
  }
}
onTargetRowSelected(event) {

  console.log(this.targetparamstemp)

  console.log(this.targetparamstemp.api.getSelectedRows())
  this.targetfieldsData = this.targetparamstemp.api.getSelectedRows();

  console.log(this.targetfieldsData)

  this.targetselectedFieldsData = this.targetfieldsData;

  console.log(this.targetselectedFieldsData);
   this.Target_UI_Section=this.targetselectedFieldsData[0].objectlabel

    //  (reset previous selection)
  this.selectedTargetParentKeys = [];
  this.targetObjectAttributesList = [];
this.selectedTargetPrimaryKeys = [];
this.selectedTransformPrimaryKeys = [];
this.selectedTransformParentKeys = [];

   if (this.targetselectedFieldsData && this.targetselectedFieldsData.length > 0) {
  const objectName = this.targetselectedFieldsData[0].objectname;

  console.log("Fetching TARGET object attributes for:", objectName);

  this.getTargetObjectAttributes(objectName, this.dnsid);
}

}
 getRouterLink(event): any[] {
  if (event.label === 'Objects') {
    return ['/user/Menubar/trnxBaseComponent'];
  } else {
    return [`/user/Menubar/${event.link}`];
  }
}

getQueryParams(label: string): any {
  if (label === 'Objects') {
    return {
      screenType: 'Dynamic/Transactions',
      tableName: 'objectmetadata',
      headerNameHtml: 'Objects'
    };
  }
  return null;
}


 

  getObjectGroup(){
          this.spinner.start();
           this.vaultObjectService.retrieveAllobjectgroup(this.localStorageSettings.getSettings("dnsName"), "Extraction Group").subscribe((res) => {
              console.log(res);
              this.objectGroupData = res;
              console.log(this.objectGroupData);
            });
            this.spinner.stop();
        }
  onObjectGroupChange(event){
          this.spinner.start();
  this.fieldsData = [];
  this.selectedFieldsData = this.fieldsData
this.Source_UI_Section=""
           console.log();
              this.objectGroupName=this.objectGroupData.filter(item=>item.objectGroupId == event.value)[0].objectGroupName;
          this.commonService.retrieveObjectsBasedOnObjectGroupId(event.value).subscribe((res:any)=>{
          console.log(res);
          if(res.error == true){
                    // this.spinner.stop(); 
                    // this.listOfObjectsWithGroup=[]
                    this.snackbar.open(res.statusMessage, "OK", {
                      duration: 5000,
                    });
                  }else{
                     let responseData:any = res
              let filteredData=responseData.filter(item=> !(item.source=="stage" && item.approvedStatus==null || item.approvedStatus == "Draft"))
                this.ObjectsData = filteredData;
                console.log(res);
                console.log(filteredData);
                const objects = filteredData.map((item: any, index: number) => ({
                   id: item.objectId || index, // Assign index if id is missing
                  objectlabel: item.objectlabel || item,
                  objectname:item.objectname||item,
                  objectlabelWithEnvName:item.objectlabelWithEnvName|| item
                })); 
 
                console.log("Mapped Objects for Grid:", objects);
                this.ObjectGrid.api.setGridOption('rowData', objects);
               this.sourceParentObjectNameList = objects.map(item => item.objectname);//added to get same values in stage/source grid
                this.ObjectGrid.api.forEachNode(node=>{      
                  console.log("objectlabel:"+node.data['objectlabel'])
                  console.log(node.data.objectlabel+"============="+this.mappingCreationData.stageobject)
                  if(node.data['objectname']===this.mappingCreationData.stageobject){
                    console.log("dns")
                       node.setSelected(true)
                       this.ObjectGrid.api.ensureNodeVisible(node);
                  }
                })
                  }
          
          // this.cdr.detectChanges();
          this.spinner.stop();
        })
  }

  importData() {
   
      console.log("<--- Inside upload Group Template --->")
      let width = "85%";
    let dialogRef = this.dialog.open(ImportJsonComponent, {
        maxWidth: "70vw",
        height: "50%",
        width: width,
      data: { "tablename": this.importExportTableName},
        disableClose: true,
      });
    
      dialogRef.afterClosed().subscribe((result) => {
        console.log(result);
    
        //this.reportCreationData = result;
    
        //this.vaultObjectService.retrieveobjectgroup();
      });
    
    
  }
  

  async exportData() {
    this.snackbar.open("Export Process is InProgress. Please do not click again the Export until it completes the Export.", "OK", { duration: 10000 });
    let tenantid = localStorage.getItem("dnsName")
   

      try {
        const blob = await this.commonService.downloadJsonFile(this.importExportTableName, tenantid);
        const link = document.createElement('a');
        const timestamp = new Date().getTime();
        link.href = window.URL.createObjectURL(blob);
        link.download = `${this.importExportTableName}_export_${timestamp}.json`;
        link.click();
        window.URL.revokeObjectURL(link.href);

      } catch (error) {
        console.error('Error downloading JSON:', error);
      }
    
    
  }
  isvalidationRequired(event){
    this.activeFlag = event
  }


  getObjectAttributes(objectName: string, tenantId: string) {
  this.commonService.getObjectAttributes(objectName,tenantId,'Source').subscribe((res: any) => {
    this.objectAttributesList = res;
  });
}

getTargetObjectAttributes(objectName: string, tenantId: string) {
  this.commonService.getObjectAttributes(objectName, tenantId,'Target').subscribe((res: any) => {
    this.targetObjectAttributesList = res;
  });
}



get isDropdownEnabled(): boolean {
  return (
    this.selectedFieldsData?.length > 0 &&
    this.targetselectedFieldsData?.length > 0 &&
    this.activeFlag === 'Yes'
  );
}

updateSelectionOrder(selectedArray: string[], changedValue: string): string[] {
  let updated = [...selectedArray];

  if (updated.includes(changedValue)) {
    // REMOVE (if unchecked)
    updated = updated.filter(v => v !== changedValue);
  } else {
    // ADD at end (maintain order)
    updated.push(changedValue);
  }

  return updated;
}

onOptionToggle(event: any, value: string, type: string) {
  if (!event.isUserInput) return;

  setTimeout(() => {

    let arr;

    switch (type) {
      case 'sourceParent': arr = [...this.selectedParentKeys]; break;
      case 'transformParent': arr = [...this.selectedTransformParentKeys]; break;
      case 'targetParent': arr = [...this.selectedTargetParentKeys]; break;
      case 'targetPrimary': arr = [...this.selectedTargetPrimaryKeys]; break;
      case 'transformPrimary': arr = [...this.selectedTransformPrimaryKeys]; break;
      default: return;
    }

    if (event.source.selected) {
      // move clicked item to end
      arr = arr.filter(v => v !== value);
      arr.push(value);
    } else {
      // remove unselected
      arr = arr.filter(v => v !== value);
    }

    // assign back AFTER Angular update
    switch (type) {
      case 'sourceParent': this.selectedParentKeys = arr; break;
      case 'transformParent': this.selectedTransformParentKeys = arr; break;
      case 'targetParent': this.selectedTargetParentKeys = arr; break;
      case 'targetPrimary': this.selectedTargetPrimaryKeys = arr; break;
      case 'transformPrimary': this.selectedTransformPrimaryKeys = arr; break;
    }

  });
}
filterTargetObjects() {
  const search = this.searchText.toLowerCase();

  this.filteredTargetObjectList = this.targetObjectDropdownList.filter(obj =>
    obj.objectlabel?.toLowerCase().includes(search)
  );
}

  }
